export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';

export const LOAD_USERS = 'LOAD_USERS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const LOAD_USERS_FAIL = 'LOAD_USERS_FAIL';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_AUTH_SUCCESS = 'INITIALIZE_AUTH_SUCCESS';
export const INITIALIZE_AUTH_FAIL = 'INITIALIZE_AUTH_FAIL';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';

export const SET_PREMIUM_USAGE = 'SET_PREMIUM_USAGE';

export const START_REFETCH_CURRENT_USER = 'START_REFETCH_CURRENT_USER';
export const REFETCH_CURRENT_USER_SUCCESS = 'REFETCH_CURRENT_USER_SUCCESS';
export const REFETCH_CURRENT_USER_FAIL = 'REFETCH_CURRENT_USER_FAIL';

export const startLoggingIn = () => {
  return {
    type: LOGIN
  };
};
export const onLoggedIn = user => {
  return {
    type: LOGIN_SUCCESS,
    user: user
  };
};
export const onLoginFailed = error => {
  return {
    type: LOGIN_FAIL,
    error: error
  };
};

export const startLoggingOut = () => {
  return {
    type: LOGOUT
  };
};
export const onLogoutFail = () => {
  return {
    type: LOGOUT_FAIL
  };
};
export const onLoggedOut = () => {
  return {
    type: LOGOUT_SUCCESS
  };
};

export const startAuthInit = () => {
  return {
    type: INITIALIZE_AUTH
  };
};
export const authInitFailed = err => {
  return {
    type: INITIALIZE_AUTH_FAIL,
    error: err
  };
};
export const authInitSuccess = user => {
  return {
    type: INITIALIZE_AUTH_SUCCESS,
    user: user
  };
};

export const loadUsers_ = () => {
  return {
    type: LOAD_USERS
  };
};

export const loadUsersFail = error => {
  return {
    type: LOAD_USERS_FAIL,
    error: error
  };
};

export const loadUsersSuccess = (users, links) => {
  return {
    type: LOAD_USERS_SUCCESS,
    users: users
  };
};

export const updateUser_ = () => {
  return {
    type: UPDATE_USER
  };
};

export const updateUserFail = err => {
  return {
    type: UPDATE_USER_FAIL,
    error: err
  };
};

export const createUser_ = () => {
  return {
    type: CREATE_USER
  };
};
export const createUserSuccess = user => {
  return {
    type: CREATE_USER_SUCCESS,
    user: user
  };
};
export const createUserFailed = error => {
  return {
    type: CREATE_USER_FAIL,
    error: error
  };
};

export const deleteUser_ = () => {
  return {
    type: DELETE_USER
  };
};
export const deleteUserSuccess = () => {
  return {
    type: DELETE_USER_SUCCESS
  };
};
export const deleteUserFailed = error => {
  return {
    type: DELETE_USER_FAIL,
    error: error
  };
};

export const setPremiumUsage = premiumUsage => {
  return {
    premiumUsage,
    type: SET_PREMIUM_USAGE
  };
};

export const startRefetchCurrentUser = () => ({
  type: START_REFETCH_CURRENT_USER
});

export const refetchCurrentUserSuccess = user => {
  return {
    type: REFETCH_CURRENT_USER_SUCCESS,
    payload: user
  };
};

export const refetchCurrentUserFail = error => ({
  type: REFETCH_CURRENT_USER_FAIL,
  payload: error
});
